import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Loading } from 'features/loading';
import { ESIA_CODE_STORAGE_KEY, LAST_PATH_STORAGE_KEY, SESSION_ID_STORAGE_KEY } from 'shared/config';

export const EsiaCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get('code');
  const state = searchParams.get('state');

  useEffect(() => {
    //TODO: нужно? Если да вынести выше
    const path = localStorage.getItem(LAST_PATH_STORAGE_KEY);
    const sessionId = localStorage.getItem(SESSION_ID_STORAGE_KEY);

    if (code && state && state === sessionId) {
      localStorage.setItem(ESIA_CODE_STORAGE_KEY, code);
    }
    if (path) {
      navigate(path);
    }
  }, [code, state, navigate]);

  return <Loading />;
};
